<div class="connexion">
    <div>
        <div>
            <img src="assets/img/logo.png" alt="SynthIA Logo" class="logo" />
          </div>
          <div>
            <img src="assets/img/logo_police_bleue.png" alt="SynthIA name" class="logot" />
          </div>
          <div>
              <div class="title">Vous êtes déconnecté</div>
          </div>

          <div>
            <div (click)="connect()" class="fakeLink">
                Se connecter
            </div>
          </div>
    </div>

</div>

